import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Loader2, LogIn, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { login, verificaSessione, onAuthChange } from "@/lib/auth";

const erroreTesto = (detail) =>
  typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((e) => e.msg).join(" ") : "Accesso non riuscito, riprova.";

export const AdminGate = ({ children }) => {
  const [stato, setStato] = useState("verifica"); // verifica | login | ok
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    verificaSessione().then((ok) => setStato(ok ? "ok" : "login"));
    return onAuthChange(() => verificaSessione().then((ok) => setStato(ok ? "ok" : "login")));
  }, []);

  const entra = async (e) => {
    e.preventDefault();
    setErrore("");
    setLoading(true);
    try {
      await login(password);
      setPassword("");
    } catch (err) {
      setErrore(erroreTesto(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (stato === "ok") return children;

  return (
    <div className="flex min-h-screen flex-col bg-xmove-night" data-testid="admin-login-page">
      <header className="border-b border-white/10">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
          <Logo dark />
          <Link to="/" data-testid="admin-login-back" className="flex items-center gap-1.5 text-sm font-semibold text-white/60 transition-colors hover:text-xmove-orange">
            <ArrowLeft size={15} /> Torna al sito
          </Link>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-5 py-16">
        {stato === "verifica" ? (
          <Loader2 className="animate-spin text-xmove-orange" size={28} data-testid="admin-login-loading" />
        ) : (
          <form onSubmit={entra} className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-md" data-testid="admin-login-form">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-xmove-orange/15 text-xmove-orange">
              <Lock size={20} />
            </span>
            <h1 className="mt-5 font-display text-2xl font-bold text-white">Area riservata</h1>
            <p className="mt-1 text-sm text-white/55">Inserisci la password per accedere al pannello di gestione XMOVE.</p>
            <label className="mt-6 block">
              <span className="mb-1.5 block text-[10px] font-bold uppercase tracking-wider text-white/50">Password</span>
              <input
                type="password"
                autoFocus
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full rounded-lg border border-white/15 bg-xmove-night px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-xmove-orange"
              />
            </label>
            {errore && <p className="mt-3 text-sm font-semibold text-red-400" data-testid="admin-login-error">{errore}</p>}
            <button
              type="submit"
              disabled={loading || !password}
              data-testid="admin-login-submit"
              className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-xmove-orange px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-xmove-orangeDark disabled:opacity-50"
            >
              {loading ? <Loader2 size={15} className="animate-spin" /> : <LogIn size={15} />} Entra
            </button>
          </form>
        )}
      </main>
    </div>
  );
};
